module.exports = __webpack_public_path__ + "static/img/rank_77.7138dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_77.png
// module id = OeP6
// module chunks = 1